import { Component } from '@angular/core';

@Component({
  selector: 'app-orders',
  template: `
                <div>
                    <router-outlet></router-outlet>
                </div>
             ` ,
})

export class OrdersComponent {

}
